<template>
  <div>
    <div v-if="allowList.length && !isAllowListEcommerce" class="holder">
      <!-- Preview section -->
      <div class="preview-section">
        <p>Preview Allow List</p>
        <span>
          Recipient List(s) synced:
          {{
            selectedRecipient
              .map((item, index) =>
                index === selectedRecipient.length - 1
                  ? item.file_name
                  : item.file_name + ', '
              )
              .join('')
          }}
          <!-- {{
            `${allowList.length} ${
              allowList.length === 1 ? 'email' : 'emails'
            } found`
          }} -->
        </span>
      </div>

      <!-- Emails Here -->
      <section class="table-holder">
        <table>
          <thead>
            <tr>
              <th>Recipient List</th>
              <th>Email</th>
              <th>Accessed Redemption Page</th>
              <th>Confirmed selections</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="user in allowList.slice(0, 5)" :key="user.id">
              <td></td>
              <td>{{ user.email }}</td>
              <td>
                <div class="dot-holder">
                  <span
                    class="dot"
                    :class="[user.accessedStore ? 'check' : 'error']"
                  ></span>
                  {{ user.accessedStore ? 'Yes' : 'No' }}
                </div>
              </td>

              <td>
                <div class="dot-holder">
                  <span
                    class="dot"
                    :class="[user.selectionsConfirmed ? 'check' : 'error']"
                  ></span>
                  {{ user.selectionsConfirmed ? 'Yes' : 'No' }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </section>

      <!-- Manage Button Here -->
      <button class="manage-list" @click="onShowModal">
        Manage Allow list
      </button>

      <!-- Modals Here -->
      <section>
        <!-- Allowed List modal here -->
        <Modal
          v-if="showModal"
          modalName="AllowedList"
          :showFooter="false"
          :isAllowList="true"
          @hideModal="onHideModal"
          colorVariation="primary"
          modalHeaderStyles="text-align: center; padding: 0rem; display: none !important"
          width="900px"
        >
          <template slot="body">
            <!-- Top header region -->
            <section class="mt-20 md:mt-12 lg:mt-0 mb-10">
              <h2 class="text-3xl text-center font-editorial-new font-light">
                Allow List
              </h2>
              <p class="text-center text-sm pt-4 name font-light">
                The following list of emails have access to
                {{ groupOrderDetails.name }}.
              </p>
            </section>

            <section class="mr-0 mt-7">
              <div class="flex items-center mt-2 mb-1 flex-nowrap w-full">
                <p class="text-left text-sm font-bold cursor-pointer pr-1">
                  Recipient List(s) synced:
                </p>
                <p class="text-sm name">
                  {{
                    selectedRecipient
                      .map((item, index) =>
                        index === selectedRecipient.length - 1
                          ? item.file_name
                          : item.file_name + ', '
                      )
                      .join('')
                  }}
                </p>
              </div>
              <!-- Search Region -->
              <section
                class="flex flex-col md:flex-row items-start md:items-end justify-between w-full gap-5 md:gap-0"
              >
                <!-- Search Input here -->

                <section class="w-3/5">
                  <div class="flex items-center mt-2 mb-1">
                    <p class="text-sm font-bold mr-1 cursor-pointer">
                      Emails found:
                    </p>
                    <p class="text-sm name">
                      {{ resultQuery.length }}
                    </p>
                  </div>
                  <!-- Add email Region -->
                  <div
                    class="flex items-center mt-3 md:mt-0 w-max md:w-3/3 justify-start add-email-section"
                  >
                    <p class="text-sm font-bold w-32 text-left cursor-pointer">
                      Add email
                    </p>

                    <div class="w-full mx-2 relative">
                      <input
                        type="text"
                        id="allow-email"
                        placeholder="Enter email"
                        v-model="email"
                        class="text-xs"
                        :class="{ input__error: $v.email.$error }"
                        @blur="$v.email.$touch()"
                      />

                      <!-- Error Display Here -->
                      <div v-if="$v.email.$error">
                        <div class="error-holder">
                          <span v-if="!$v.email.email"
                            >Invalid input. Please try again.</span
                          >
                          <span v-else> This field is required. </span>
                        </div>
                      </div>
                    </div>

                    <button
                      class="button-gemnote button-gemnote--tiny px-6"
                      @click="addSingleEmail"
                      :disabled="loadingAllowList"
                    >
                      <span>Add</span>
                    </button>
                  </div>
                </section>
                <div class="md:w-2/5 relative">
                  <Search
                    placeholder="SEARCH BY EMAIL"
                    @input="value => (searchQuery = value)"
                  />
                </div>
              </section>

              <!-- Control region here -->
              <section class="flex items-center mt-12 mx-5">
                <!-- <p class="text-xs name">
                  <strong>{{ resultQuery.length }}</strong>
                  {{ resultQuery.length === 1 ? 'Email' : 'Emails' }}
                </p> -->

                <div
                  class="ml-auto flex items-center mr-5"
                  @click="removeUsers('all')"
                >
                  <img
                    src="../../assets/trash.svg"
                    alt=""
                    class="cursor-pointer"
                  />
                  <p
                    class="ml-auto text-sm cursor-pointer font-bold underline name pl-1"
                  >
                    Remove All
                  </p>
                </div>
              </section>

              <!-- Table here -->
              <section class="mt-3">
                <vue-good-table
                  :columns="columns"
                  :rows="resultQuery"
                  styleClass="vgt-table allowlist-table"
                >
                  <template slot="table-column" slot-scope="list">
                    <span
                      v-if="list.column.field === 'delete'"
                      class="flex justify-end items-center"
                    >
                      <p class="flex">
                        {{ list.column.label }}
                        <span class="ml-2 tooltip-holder">
                          <Tooltip
                            :pop-over-content="tooltipContent"
                            :pop-over-position="tooltipPosition"
                            :is-allow-list="true"
                            popoverWrapperClass="relative md:-right-56 md:top-8"
                          />
                        </span>
                      </p>
                    </span>
                  </template>
                  <template slot="table-row" slot-scope="list">
                    <span v-if="list.column.field === 'recipientList'">
                      <div class="flex items-center justify-center"></div>
                    </span>
                    <span v-else-if="list.column.field === 'accessedStore'">
                      <div class="flex items-center justify-center">
                        <span
                          class="dot"
                          :class="[
                            list.row[list.column.field] ? 'check' : 'error'
                          ]"
                        ></span>
                        {{ list.row[list.column.field] ? 'Yes' : 'No' }}
                      </div>
                    </span>

                    <span
                      v-else-if="list.column.field === 'selectionsConfirmed'"
                    >
                      <div class="flex items-center justify-center">
                        <span
                          class="dot"
                          :class="[
                            list.row[list.column.field] ? 'check' : 'error'
                          ]"
                        ></span>
                        {{ list.row[list.column.field] ? 'Yes' : 'No' }}
                      </div>
                    </span>

                    <!-- Delete Region Here -->
                    <span
                      v-else-if="list.column.field === 'delete'"
                      class="delete"
                    >
                      <div
                        class="flex items-center justify-center cursor-pointer"
                        :class="{
                          'cursor-not-allowed opacity-50': orderFinalized(
                            list.row
                          )
                        }"
                        @click="removeUsers('single', list.row)"
                      >
                        <span v-if="orderFinalized(list.row)"
                          >Order finalized</span
                        >
                        <img src="../../assets/trash.svg" alt="" v-else />
                      </div>
                    </span>
                  </template>

                  <div slot="emptystate">
                    There are no items to display.
                  </div>
                </vue-good-table>
              </section>
            </section>
          </template>
        </Modal>
      </section>
    </div>
    <div
      v-else-if="isAllowListEcommerce && ecommerceAllowListLength"
      class="holder"
    >
      <!-- Preview section -->
      <div class="preview-section">
        <p>Preview</p>
        <span>
          {{
            `${allowListEcommerce.data.length} ${
              allowListEcommerce.data.length === 1 ? 'email' : 'emails'
            } found`
          }}
        </span>
      </div>

      <!-- Emails Here -->
      <table>
        <thead>
          <tr>
            <th>Email</th>
            <th>Verified</th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="(user, index) in allowListEcommerce.data.slice(0, 5)"
            :key="index"
          >
            <td>{{ user.attributes.email }}</td>
            <td>
              <div class="img-holder">
                <img
                  :src="
                    require(`../../assets/${
                      user.attributes.verified ? 'check' : 'error'
                    }.svg`)
                  "
                  alt="check"
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Manage Button Here -->
      <button class="manage-list" @click="showModal = true">
        Manage List
      </button>

      <!-- Modals Here -->
      <section>
        <!-- Allowed List modal here -->
        <Modal
          v-if="showModal"
          modalName="AllowedList"
          :showFooter="false"
          :isAllowList="true"
          @hideModal="onHideModal"
          colorVariation="primary"
          width="900px"
        >
          <template slot="body">
            <!-- Top header region -->
            <section class="mt-1 mb-5">
              <h2 class="text-3xl text-center font-editorial-new font-light">
                Allow List
              </h2>
              <p class="text-center text-sm pt-4 name font-light">
                The following list of emails have access to
                {{ shopDetails.title }}.
              </p>
            </section>

            <section class="mr-0">
              <!-- Search Region -->
              <section class="flex items-center mt-7">
                <!-- Search Input here -->
                <div class="w-2/5 relative">
                  <Search
                    placeholder="SEARCH BY EMAIL"
                    @input="value => (searchQuery = value)"
                  />
                </div>

                <!-- Add email Region -->
                <div class="ml-auto flex items-center w-2/3 justify-end">
                  <p class="text-sm font-bold mr-1 cursor-pointer">Add email</p>

                  <div class="w-2/5 mx-4 relative">
                    <input
                      type="text"
                      id="allow-email"
                      placeholder="Enter email"
                      v-model="email"
                      class="text-sm"
                      :class="{ input__error: $v.email.$error }"
                      @blur="$v.email.$touch()"
                    />

                    <!-- Error Display Here -->
                    <div v-if="$v.email.$error">
                      <div class="error-holder">
                        <span v-if="!$v.email.email"
                          >Invalid input. Please try again.</span
                        >
                        <span v-else> This field is required. </span>
                      </div>
                    </div>
                  </div>

                  <button
                    class="button-gemnote button-gemnote--tiny px-6"
                    @click="addSingleEmail"
                    :disabled="loadingAllowList"
                  >
                    <span>Add</span>
                  </button>
                </div>
              </section>

              <!-- Control region here -->
              <section class="flex items-center mt-12 mx-5 ">
                <p class="text-xs name">
                  <strong>{{ resultQueryEcommerce.length }}</strong>
                  {{ resultQueryEcommerce.length === 1 ? 'Email' : 'Emails' }}
                </p>

                <div class="ml-auto flex items-center mr-10">
                  <p
                    class="ml-auto text-sm cursor-pointer font-bold underline name "
                    @click="removeUsers('all')"
                  >
                    Remove All
                  </p>
                </div>
              </section>

              <!-- Table here -->
              <section class="mt-3 mx-10">
                <vue-good-table
                  :columns="setColumn"
                  :rows="resultQueryEcommerce"
                  styleClass="vgt-table allowlist-table-ecommerce"
                >
                  <template slot="table-column" slot-scope="list">
                    <span
                      v-if="list.column.field === 'remove'"
                      class="flex justify-end items-center"
                    >
                      <p class="flex">
                        {{ list.column.label }}
                        <span class="ml-2 tooltip-holder">
                          <Tooltip
                            :pop-over-content="tooltipContent"
                            :pop-over-position="tooltipPosition"
                            :is-allow-list="true"
                          />
                        </span>
                      </p>
                    </span>
                  </template>
                  <template slot="table-row" slot-scope="list">
                    <span v-if="list.column.field === 'email'">
                      {{ list.row.attributes.email }}
                    </span>
                    <span v-if="list.column.field === 'verified'">
                      <div class="flex items-center justify-center">
                        <img
                          :src="
                            require(`../../assets/${
                              list.row.attributes.verified ? 'check' : 'error'
                            }.svg`)
                          "
                          alt="check"
                        />
                      </div>
                    </span>

                    <!-- Delete Region Here -->
                    <span
                      v-else-if="list.column.field === 'remove'"
                      class="delete"
                    >
                      <div
                        v-if="list.row.attributes.orderPlaced"
                        class="flex items-center justify-center list-has-order"
                      >
                        Order placed
                      </div>
                      <div
                        v-else
                        class="flex items-center justify-center cursor-pointer"
                        :class="{
                          'cursor-not-allowed opacity-50': orderFinalized(
                            list.row
                          )
                        }"
                        @click="removeUsers('single', list.row)"
                      >
                        x
                      </div>
                    </span>
                  </template>

                  <div slot="emptystate" class="text-center">
                    There are no items to display.
                  </div>
                </vue-good-table>
              </section>
            </section>
          </template>
        </Modal>
      </section>
    </div>
    <!-- Remove Allowed List modal here -->
    <Modal
      v-if="showRemoveModal"
      modalName="RemoveAllowedList"
      @hideModal="showRemoveModal = false"
      :buttonLabel="removalType === 'single' ? 'Confirm' : 'Remove all'"
      @confirmAction="handleUserRemoval"
      colorVariation="secondary"
    >
      <template slot="header">
        <h2 class=" editorial header">
          {{ removalType === 'single' ? 'Remove User' : 'Remove All' }}
        </h2>
      </template>

      <template slot="body">
        <p v-if="removalType === 'single'" class="pt-4 text-center font-light">
          Are you sure you want to remove
          <strong>{{
            !isAllowListEcommerce ? activeRow.email : activeRow.attributes.email
          }}</strong>
          from this list?
        </p>
        <p v-else class="pt-4 text-center font-light mb-12">
          Are you sure you want to remove all emails from Allow List? Removing
          all emails will clear your Allow List.
        </p>
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/Universal/RemoveModal.vue'
import Tooltip from '@/components/Universal/ToolTipInfo.vue'
import { VueGoodTable } from 'vue-good-table'
import { mapState } from 'vuex'
import { email, required } from 'vuelidate/lib/validators'
import Search from '@/components/Universal/Search.vue'
export default {
  name: 'AllowList',
  components: { Modal, Tooltip, VueGoodTable, Search },

  props: {
    groupOrderDetails: {
      type: Object,
      default: () => {}
    },
    shopDetails: {
      type: Object,
      default: () => {}
    },
    isAllowListEcommerce: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    showModal: false,
    showRemoveModal: false,
    searchQuery: '',
    email: '',
    removalType: '',
    activeRow: {},
    tooltipContent: `<span>Access can be removed only for orders that are not finalized.  <br /> <br />
To remove access of an ‘Order Finalized’ recipient, navigate to <b>Redemptions </b> tab, select recipient <b>Email</b> and click delete.
</span>`,

    columns: [
      {
        label: 'Recipient List',
        field: 'recipientList',
        width: '20%'
      },
      {
        label: 'Email',
        field: 'email'
      },

      {
        label: 'Accessed Redemption Page',
        field: 'accessedStore',
        width: '35%'
      },

      {
        label: 'Confirmed selections',
        field: 'selectionsConfirmed',
        width: '25%'
      },

      {
        label: 'Remove access',
        field: 'delete',
        width: '25%'
      }
    ],
    ecommerceColumns: [
      {
        label: 'Email',
        field: 'email',
        width: '25%'
      },
      {
        label: 'Verified',
        field: 'verified',
        width: '25%'
      },
      {
        label: 'Remove Access',
        field: 'remove',
        width: '25%'
      }
    ]
  }),

  validations: {
    email: { required, email }
  },

  watch: {
    removeAllUsers: {
      handler: function(val) {
        if (val) {
          this.showModal = false
        }
      },
      deep: true,
      immediate: true
    }
  },

  computed: {
    ...mapState({
      allowList: state => state.groupOrder.allowList,
      allowListEcommerce: state => state.groupOrder.allowListEcommerce,
      loadingAllowList: state => state.groupOrder.loadAllowList,
      removeAllUsers: state => state.groupOrder.removeAllUsers,
      selectedRecipient: state => state.recipient.selectedRecipientList
    }),

    resultQuery() {
      if (this.searchQuery) {
        return this.allowList.filter(user => {
          return this.searchQuery
            .toLowerCase()
            .split(' ')
            .every(v => user.email.toLowerCase().includes(v))
        })
      } else {
        return this.allowList
      }
    },
    setColumn() {
      if (!this.isAllowListEcommerce) {
        return this.columns
      } else {
        return this.ecommerceColumns
      }
    },
    resultQueryEcommerce() {
      if (this.searchQuery) {
        return this.allowListEcommerce.data.filter(user => {
          return this.searchQuery
            .toLowerCase()
            .split(' ')
            .every(v => user.attributes.email.toLowerCase().includes(v))
        })
      } else {
        return this.allowListEcommerce.data
      }
    },

    tooltipPosition() {
      if (this.innerWidth < 1000) {
        return 'bottom-start'
      }
      return 'right'
    },
    ecommerceAllowListLength() {
      return this.allowListEcommerce.data
        ? this.allowListEcommerce.data.length && this.isAllowListEcommerce
        : false
    }
  },

  mounted() {
    if (this.isAllowListEcommerce === true) {
      this.loadAllowListEcommerce()
    } else {
      this.loadAllowList()
    }
  },

  methods: {
    onShowModal() {
      this.showModal = true
      this.$store.dispatch('modal/setAllowListModal', true)
    },
    onHideModal() {
      this.showModal = false
      this.searchQuery = ''
      this.$store.dispatch('globalTracking/changeSearchTerm', '')
      this.$store.dispatch('modal/setAllowListModal', false)
    },
    loadAllowList() {
      this.$store.dispatch(
        'groupOrder/loadAllowList',
        this.groupOrderDetails.id
      )
    },
    loadAllowListEcommerce() {
      this.$store.dispatch('groupOrder/loadAllowListEcommerce')
    },
    orderFinalized(row) {
      return row.accessedStore && row.selectionsConfirmed
    },

    removeAllowedEmail(row) {
      this.activeRow = row
      this.showRemoveModal = true
    },

    removeUsers(type, row) {
      if (type === 'single') {
        if (this.orderFinalized(row)) {
          return
        }
        this.activeRow = row
      }

      this.removalType = type
      this.showRemoveModal = true
    },

    handleUserRemoval() {
      if (!this.isAllowListEcommerce) {
        if (this.removalType === 'single') {
          this.$store.dispatch('groupOrder/removeAllowedEmail', {
            groupOrderId: this.groupOrderDetails.id,
            userId: this.activeRow.id
          })
        } else {
          this.$store.dispatch('groupOrder/removeAllUsers', {
            id: this.groupOrderDetails.id,
            payload: this.allowList.map(user => user.id)
          })
        }

        this.$store.dispatch('recipient/setSelectedRecipientList', {
          value: null
        })
      } else {
        if (this.removalType === 'single') {
          this.$store.dispatch('groupOrder/removeSingleAllowedEmailEcommerce', {
            userId: this.activeRow.id
          })
          this.$store.dispatch('recipient/loadEcommerceRecipientList')
        } else {
          const allowListIds = [
            ...new Set(
              this.allowListEcommerce.data.map(
                item => item.attributes.eCommerceAllowListId
              )
            )
          ]
          allowListIds.map(ids => {
            this.$store.dispatch('groupOrder/removeAllowedEmailEcommerce', {
              id: ids
            })
          })
          this.$store.dispatch('recipient/loadEcommerceRecipientList')
        }
      }
      this.showRemoveModal = false
    },

    addSingleEmail() {
      console.log(this.isAllowListEcommerce)
      this.$v.$touch()
      if (this.$v.$error === true) {
        return
      }
      if (!this.isAllowListEcommerce) {
        let existingEmail = this.allowList.find(
          email => email.email === this.email
        )
        if (existingEmail) {
          this.$store.dispatch('notification/pushNotification', {
            type: 'error',
            messages: [`${this.email}  already exists.`]
          })
        } else {
          this.$store.dispatch('groupOrder/addSingleEmail', {
            id: this.groupOrderDetails.id,
            email: this.email
          })
        }
      } else {
        let existingEmail = this.allowListEcommerce.data.find(
          email => email.attributes.email === this.email
        )
        console.log(existingEmail)
        if (existingEmail) {
          this.$store.dispatch('notification/pushNotification', {
            type: 'error',
            messages: [`${this.email}  already exists.`]
          })
        } else {
          this.$store.dispatch('groupOrder/uploadAllowListEcommerce', {
            type: 'list',
            email: this.email
          })
        }
      }

      this.email = ''
      this.$v.$reset()
    }
  }
}
</script>

<style lang="scss" scoped>
// @import '@/global.scss';

h2.header {
  font-size: 2rem;
  // font-family: $editorial;
  // color: $pebble;
  font-weight: normal;
  text-align: center;
  line-height: 30px;
}

.font-editorial-new {
  font-family: 'Editorial New' !important;
}

.font-light {
  font-weight: normal !important;
}

.holder {
  margin: 1.125rem 0;

  .preview-section {
    display: flex;
    align-items: flex-start;
    flex-direction: column;

    p {
      font-size: 0.785rem;
      font-weight: 600;
      margin-right: 1.25rem;
    }

    span {
      display: block;
      padding-top: 3px;
      color: #514d43;
      font-size: 0.725rem;
    }
  }

  .table-holder {
    width: 100%;
    overflow: auto;
  }
  table {
    margin-top: 1.25rem;

    thead {
      tr {
        border: 0.5px solid #a09c95;
      }
    }

    th {
      color: #000000;
      font-size: 0.75rem;
      font-weight: bold;
      padding-bottom: 0.75rem;
      text-align: left;
      padding: 10px;
      border: 0.5px solid #a09c95;
      border-top: 1px solid #a09c95;
      border-bottom: 1px solid #a09c95;

      &:first-child {
        width: 25%;
        text-align: left;
      }
    }

    td {
      color: #232220;
      font-size: 0.75rem;
      text-align: center;
      padding: 15px 10px;
      text-align: left;
      border-bottom: 1px solid #a09c95;

      &:first-child {
        width: 15%;
        text-align: left;
      }

      .dot-holder {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .img-holder {
        display: flex;
        justify-content: center;
        margin-left: 20px;
      }
    }
  }

  .name {
    color: #24292c;
  }

  input {
    &::placeholder {
      font-size: 0.875rem;
      color: #6c7a7b;
    }

    &.input__error {
      border-bottom: 1px solid #da5737;
    }
  }

  button.manage-list {
    text-transform: capitalize;
    border-radius: 40px;
    background: transparent;
    height: 32px;
    display: flex;
    align-items: center;
    color: #24292c;
    font-size: 0.813rem;
    margin-top: 1.25rem;
    text-decoration: underline;
  }
}

.tooltip-holder {
  display: inline-block;
  position: relative;
  top: 1px;
}

.error-holder {
  position: absolute;
  text-align: left;
  font-size: 0.625rem;
  color: #da5737;
  padding-top: 0px;
  font-weight: bold;
}
.list-has-order {
  color: #232220;
}
button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.add-email-section {
  input {
    height: 100%;
    min-width: 140px;
    margin: 0px;
  }
}
.button-gemnote--tiny {
  font-weight: 400 !important;
}
.dot {
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 6px;
  &.check {
    background-color: #68c67e;
  }
  &.error {
    background-color: #ce3c3c;
  }
}
</style>
